var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("div", { staticClass: "home-header" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home-banner" },
        [
          _c(
            "awesome-swiper",
            {
              attrs: {
                name: "home-banner",
                pagination: false,
                turnPages: false
              },
              on: { showLoginHandle: _vm.showLoginHandle }
            },
            [
              _c("swiper-slide", [
                _c("div", { staticClass: "banner-content" }, [
                  _c("div", { staticClass: "banner-content-img" }, [
                    _c("img", {
                      staticClass: "pc-banner",
                      attrs: {
                        src:
                          "https://master-shopvidi.s3.amazonaws.com/index_images/banner.61fc644.jpg",
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "m-banner",
                      attrs: {
                        src:
                          "https://master-shopvidi.s3.amazonaws.com/index_images/banner_mobile.png",
                        alt: ""
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "banner-content-text" }, [
                    false
                      ? _c("div", { staticClass: "banner-title" }, [
                          _vm._v("TRUSTED BRANDS")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "banner-subtitle" }, [
                      _vm._v("Wholesale like a Big Box")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "banner-ins" }, [
                      _vm._v(
                        "Your One-Stop Shop for Wholesale Trendy Unique IPs and Branded Lifestyle Goods"
                      )
                    ]),
                    _vm._v(" "),
                    !_vm.login
                      ? _c(
                          "div",
                          {
                            staticClass: "banner-button",
                            on: { click: _vm.showLoginHandle }
                          },
                          [_vm._v("Sign Up to Shop")]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "home-list" }, [
        _c("div", { staticClass: "home-list-w" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "list-w-content" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "w-title" }, [
              _vm._v("Flexible payments.")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-ins" }, [
              _vm._v(
                "\n            Buy now, pay later. We offer generous payments methods, such as 60 day payment terms.\n            "
              ),
              _c(
                "span",
                {
                  staticClass: "w-ins-underline",
                  on: {
                    click: function($event) {
                      return _vm.open("/credit-payment")
                    }
                  }
                },
                [_vm._v("Check 60 day payment terms")]
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(2)
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "home-store" }, [
        _c("div", { staticClass: "home-title" }, [
          _vm._v("Gift Shop Exclusive Shelves")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "home-store-swiper" },
          [
            _c(
              "awesome-swiper",
              {
                attrs: {
                  pagination: _vm.pagination,
                  turnPages: _vm.turnPages,
                  swiperData: _vm.store,
                  prevName: "store",
                  nextName: "store"
                }
              },
              _vm._l(_vm.storeList, function(e, i) {
                return _c("swiper-slide", { key: i }, [
                  _c("div", { staticClass: "store-swiper-list" }, [
                    _c("div", { staticClass: "store-swiper-img" }, [
                      _c("img", {
                        attrs: { src: e.img, alt: "", openurl: e.url }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "store-swiper-text",
                        attrs: { openurl: e.url }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(e.text) +
                            "\n              "
                        )
                      ]
                    )
                  ])
                ])
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vilocal-zone-main1" }, [
        !_vm.isMobile
          ? _c("div", { staticClass: "banner" }, [
              _c(
                "div",
                {
                  staticClass: "banner-btn",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "vilocal" })
                    }
                  }
                },
                [_vm._v("Get free trial sales NOW!")]
              ),
              _vm._v(" "),
              false
                ? _c("img", {
                    staticClass: "vilocal-zone-main1-pc-rules",
                    attrs: {
                      src: require("@/assets/img/vilocal/vilocal-rules.png")
                    }
                  })
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        false
          ? _c("img", {
              staticClass: "vilocal-zone-main1-m-rules",
              attrs: { src: require("@/assets/img/vilocal/m-rules.png") }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isMobile
          ? _c(
              "div",
              {
                staticClass: "banner-btn-m",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ name: "vilocal" })
                  }
                }
              },
              [_vm._v("Get free trial sales NOW!")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "new-brands" }, [
        _c("div", { staticClass: "home-title" }, [_vm._v("Most Popular IPs")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "brands-swiper" },
          [
            _c(
              "awesome-swiper",
              {
                attrs: {
                  pagination: _vm.pagination,
                  turnPages: _vm.turnPages,
                  swiperData: _vm.store,
                  prevName: "mostPopularBrands",
                  nextName: "mostPopularBrands"
                }
              },
              _vm._l(_vm.mostPopularBrands, function(e, i) {
                return _c("swiper-slide", { key: i }, [
                  _c(
                    "div",
                    {
                      staticClass: "brands-swiper-list",
                      on: {
                        click: function($event) {
                          return _vm.open(e.url)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "brands-swiper-img" }, [
                        _c("img", {
                          attrs: { src: e.img, alt: "", openurl: e.url }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "brands-swiper-text",
                          attrs: { openurl: e.url }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(e.text) +
                              "\n              "
                          )
                        ]
                      )
                    ]
                  )
                ])
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "new-brands top-brands" }, [
        _c("div", { staticClass: "home-title" }, [_vm._v("Shipping from US")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "brands-swiper" },
          [
            _c(
              "awesome-swiper",
              {
                attrs: {
                  pagination: _vm.pagination,
                  turnPages: _vm.turnPages,
                  swiperData: _vm.store,
                  prevName: "topbrands1",
                  nextName: "topbrands1"
                }
              },
              _vm._l(_vm.shippingFromUSAList, function(e, i) {
                return _c("swiper-slide", { key: i }, [
                  _c(
                    "div",
                    {
                      staticClass: "brands-swiper-list",
                      on: {
                        click: function($event) {
                          return _vm.open(e.url)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "brands-swiper-img" }, [
                        _c("img", {
                          attrs: { src: e.img, alt: "", openurl: e.url }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "brands-swiper-text",
                          attrs: { openurl: e.url }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(e.text) +
                              "\n              "
                          )
                        ]
                      )
                    ]
                  )
                ])
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "new-brands" }, [
        _c("div", { staticClass: "home-title" }, [_vm._v("New Brands")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "brands-swiper" },
          [
            _c(
              "awesome-swiper",
              {
                attrs: {
                  pagination: _vm.pagination,
                  turnPages: _vm.turnPages,
                  swiperData: _vm.store,
                  prevName: "brands",
                  nextName: "brands"
                }
              },
              _vm._l(_vm.brandsList, function(e, i) {
                return _c("swiper-slide", { key: i }, [
                  _c(
                    "div",
                    {
                      staticClass: "brands-swiper-list",
                      on: {
                        click: function($event) {
                          return _vm.open(e.url)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "brands-swiper-img" }, [
                        _c("img", {
                          attrs: { src: e.img, alt: "", openurl: e.url }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "brands-swiper-text",
                          attrs: { openurl: e.url }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(e.text) +
                              "\n              "
                          )
                        ]
                      )
                    ]
                  )
                ])
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.login
        ? _c("div", { staticClass: "home-best-sellers new-brands" }, [
            _c("div", { staticClass: "home-title" }, [
              _vm._v("Best Sellers List")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "brands-swiper" },
              [
                _c(
                  "awesome-swiper",
                  {
                    attrs: {
                      pagination: _vm.pagination,
                      turnPages: _vm.turnPages,
                      swiperData: _vm.bestStore,
                      prevName: "bestsellers",
                      nextName: "bestsellers"
                    }
                  },
                  _vm._l(_vm.bestSellersList, function(e, i) {
                    return _c("swiper-slide", { key: i }, [
                      _c(
                        "div",
                        [
                          _c("CardCom", {
                            attrs: {
                              data: [e],
                              type: 5,
                              source: "home",
                              isShowBrandTag: true
                            }
                          })
                        ],
                        1
                      )
                    ])
                  }),
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.login
        ? _c("div", { staticClass: "new-brands top-brands" }, [
            _c("div", { staticClass: "home-title" }, [_vm._v("Top Brands")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "brands-swiper" },
              [
                _c(
                  "awesome-swiper",
                  {
                    attrs: {
                      pagination: _vm.pagination,
                      turnPages: _vm.turnPages,
                      swiperData: _vm.store,
                      prevName: "topbrands",
                      nextName: "topbrands"
                    }
                  },
                  _vm._l(_vm.topBrandsList, function(e, i) {
                    return _c("swiper-slide", { key: i }, [
                      _c(
                        "div",
                        {
                          staticClass: "brands-swiper-list",
                          on: {
                            click: function($event) {
                              return _vm.open(e.url)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "brands-swiper-img" }, [
                            _c("img", {
                              attrs: { src: e.img, alt: "", openurl: e.url }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "brands-swiper-text",
                              attrs: { openurl: e.url }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(e.text) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  }),
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "home-store shop" }, [
        _c("div", { staticClass: "home-title" }, [
          _vm._v("Shop by Categories")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "home-store-swiper" },
          [
            _c(
              "awesome-swiper",
              {
                attrs: {
                  pagination: false,
                  turnPages: false,
                  swiperData: _vm.store,
                  prevName: "shop",
                  nextName: "shop"
                }
              },
              _vm._l(_vm.shopList, function(e, i) {
                return _c("swiper-slide", { key: i }, [
                  _c(
                    "div",
                    {
                      staticClass: "store-swiper-list",
                      on: {
                        click: function($event) {
                          return _vm.open(e.url)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "store-swiper-img" }, [
                        _c("img", {
                          attrs: { src: e.img, alt: "", openurl: e.url }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "store-swiper-text",
                          attrs: { openurl: e.url }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(e.text) +
                              "\n              "
                          )
                        ]
                      )
                    ]
                  )
                ])
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "home-collapse" }, [
        _c("div", { staticClass: "home-collapse-content" }, [
          _c("div", { staticClass: "home-collapse-text" }, [
            _c("div", [_vm._v("Your wholesale connection to global brands")]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n            Discover the power of ShopVidi, your direct access to global brands. Join us to explore a world of creative, innovative, and fashionable products for your retail business.\n          "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function($event) {
                    return _vm.open("/about")
                  }
                }
              },
              [_vm._v("Our Story")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "home-collapse-components" },
            [
              _c("div", { staticClass: "collapse-components-title" }, [
                _vm._v("How it works?")
              ]),
              _vm._v(" "),
              _c("collapse")
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "reviews", staticClass: "home-reviews" },
        [
          _c("h2", { staticClass: "goods-comments-area" }, [
            _vm._v("Most Recent Customer Reviews")
          ]),
          _vm._v(" "),
          _c("ReviewsList")
        ],
        1
      ),
      _vm._v(" "),
      false
        ? _c("div", { staticClass: "home-bottom" }, [
            _c(
              "div",
              { staticClass: "home-bottom-swiper" },
              [
                _c(
                  "awesome-swiper",
                  {
                    attrs: {
                      pagination: true,
                      turnPages: false,
                      swiperData: _vm.bottomStore,
                      prevName: "bottom",
                      nextName: "bottom"
                    }
                  },
                  _vm._l(_vm.bottomList, function(e, i) {
                    return _c("swiper-slide", { key: i }, [
                      _c("div", { staticClass: "bottom-swiper-list" }, [
                        _c("div", [
                          _c("img", { attrs: { src: e.img, alt: "" } })
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                " +
                              _vm._s(e.text) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(e.title))])
                      ])
                    ])
                  }),
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("home-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-w-content" }, [
      _c("div", { staticClass: "w-img" }, [
        _c("img", {
          attrs: { src: require("@/assets/img/home/smarter.png"), alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-title" }, [_vm._v("Shop smarter.")]),
      _vm._v(" "),
      _c("div", { staticClass: "w-ins" }, [
        _vm._v(
          "\n            Discover thousands of trendy IP and branded products directly, and purchase at a great wholesale price\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-img" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/home/payments.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-w-content" }, [
      _c("div", { staticClass: "w-img" }, [
        _c("img", {
          attrs: { src: require("@/assets/img/home/freeShipping.png"), alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-title" }, [
        _vm._v("No MOQ & Free shipping.")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-ins" }, [
        _vm._v(
          "\n            Each opening order has no minimum spend and free shipping, plus the option to reorder at low minimum\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b685826", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b685826","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/index.vue
// module id = null
// module chunks = 